module.exports = __webpack_public_path__ + "static/img/1688.8b1c8333.png";